import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import {
  operations as siteOperations,
  selectors as siteSelectors,
  actions as siteActions,
} from 'store/siteManager'
import KickoffModalComponent from './component'

const KickoffModalContainer = ({
  clearError,
  flowLabel,
  handleClose,
  kickoffPrepared,
  modals,
  siteId,
  updateSitePreferences,
}) => {
  const [currentStep, setCurrentStep] = useState(0)

  const closeModal = () => {
    clearError('sitePreferences')
    handleClose()
  }

  const goBack = () => {
    handleStepChange(currentStep - 1)
  }

  const handleNextButtonClick = () => {
    if (currentStep === 0) {
      handleStepChange(currentStep + 1)
    } else {
      updateSitePreferences(siteId, {
        k5Digital: {
          kickoffPrepared: true,
        },
        mspDigital: {
          kickoffPrepared: true,
        },
      })
      closeModal()
    }
  }

  const handleStepChange = toStep => setCurrentStep(toStep)

  useEffect(() => {
    if (kickoffPrepared) {
      setCurrentStep(1)
    }
  }, [kickoffPrepared])

  if (!modals) return null

  return (
    <KickoffModalComponent
      currentStep={currentStep}
      flowLabel={flowLabel}
      goBack={goBack}
      handleClose={closeModal}
      handleNextButtonClick={handleNextButtonClick}
      modals={modals}
    />
  )
}

KickoffModalContainer.propTypes = {
  clearError: PropTypes.func,
  flowLabel: PropTypes.string,
  handleClose: PropTypes.func,
  kickoffPrepared: PropTypes.bool,
  modals: PropTypes.array,
  siteId: PropTypes.number,
  updateSitePreferences: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  const site = siteSelectors?.selectSiteById(state, ownProps.siteId)
  const { sitePreferences = {} } = site || {}
  const { k5Digital = {} } = sitePreferences
  const { kickoffPrepared } = k5Digital
  const { sitePreferences: sitePreferencesAPIResults } = state.siteManager
  const { error } = sitePreferencesAPIResults

  return {
    hasApiError: !!error,
    site,
    kickoffPrepared,
  }
}

const mapDispatchToProps = {
  updateSitePreferences: siteOperations.updateSitePreferences,
  clearError: siteActions.clearError,
}

const mapper = entry => {
  const { modals, flowLabel } = entry || {}

  return {
    modals,
    flowLabel,
  }
}

const options = {
  entryId: '5QTwWUfk4bOE1IY2hvVZRz',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    KickoffModalContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
